import mitt from 'mitt'
export const Emitter = mitt()
